import { Card, CardActions, CardContent, Grid, Skeleton } from '@mui/material';
import { CerebroDrawer, CerebroHeading, CerebroLabel, CerebroText } from '../../../shared/components';
import { useDataRoomNotesQuery } from '../../../shared/hooks';
import { DataRoomUser } from '../../../shared/models';
import { DateUtils } from '../../../shared/utils';

interface ViewLenderNotesProps {
	dataRoomGuid: string | undefined;
	user: DataRoomUser | null;
	close: () => void;
}

export const ViewLenderNotes: React.FC<ViewLenderNotesProps> = ({ dataRoomGuid, user, close }) => {
	const notesQuery = useDataRoomNotesQuery(dataRoomGuid, user?.guid, {
		enabled: user != null,
		retry: false,
	});

	return (
		<CerebroDrawer open={user != null} onClose={() => close()} PaperProps={{ sx: { width: '500px' } }}>
			<CerebroHeading size="h1" gutterBottom>
				{user?.firstName} {user?.lastName} ({user?.bankName})
			</CerebroHeading>

			{notesQuery.isLoading && (
				<>
					<Skeleton height={60} />
					<Skeleton height={60} />
					<Skeleton height={60} />
				</>
			)}

			{notesQuery.isSuccess && (
				<>
					{notesQuery.data.map(note => {
						return (
							<Grid key={note.guid} item xs={12}>
								<Card
									elevation={3}
									sx={{
										display: 'flex',
										justifyContent: 'space-between',
										flexDirection: 'column',
										height: '100%',
										marginBottom: 2,
									}}
								>
									<CardContent sx={{ paddingBottom: '0 !important' }}>
										<Grid container sx={{ marginBottom: 2 }}>
											<Grid item xs={12}>
												<CerebroText
													variant="large"
													component="span"
													sx={{ fontWeight: 'bold' }}
												>
													{DateUtils.FormatStringAsShortDate(note.createdOn?.toString())}
												</CerebroText>
											</Grid>
										</Grid>
										<CerebroText gutterBottom sx={{ marginTop: 1 }}>
											{note.details}
										</CerebroText>
									</CardContent>
									<CardActions
										sx={theme => ({
											alignItems: 'flex-end',
											backgroundColor: theme.palette.gray.background,
											borderTop: `1px solid ${theme.palette.divider}`,
											justifyContent: 'space-between',
										})}
									>
										<CerebroText>Created By {note.createdByName}</CerebroText>
									</CardActions>
								</Card>
							</Grid>
						);
					})}
					{notesQuery.data.length == 0 && <></>}
				</>
			)}
		</CerebroDrawer>
	);
};
